import React, { Fragment } from "react";
import { useFieldLookup } from "../../../../hooks/useFieldLookup";
import { usersCachingService } from "../../../../services";
import { ActivitySkeleton } from "./ActivitySkeleton";
import { Flagged } from "./Flagged";
import { Typography, Divider } from "@material-ui/core";
import { DocumentDownloadAttachment } from "./DocumentDownloadAttachment";
import { useIsReady } from "../../../../hooks/useIsReadyHook";
const formatText = (text) => {
    const imageRegex = /\[cid\:(image[0-9]{3}\.(jpg|jpeg|png|gif|tiff|svg|webp|ico))\@([0-9A-Z.]+)\]/g;
    return text
        .replace(imageRegex, (_, groupOne) => `See attachment: ${groupOne}`)
        .split("\n")
        .map((item, key) => {
        return (React.createElement(Fragment, { key: key },
            item,
            React.createElement("br", null)));
    });
};
export const Email = ({ model, onToggle, disabled, onIsReady }) => {
    const { eventMeta, caseId, id } = model;
    const createdByName = useFieldLookup(usersCachingService, model.createdBy);
    const isReady = createdByName;
    useIsReady(!!isReady, onIsReady);
    return !isReady ? (React.createElement(ActivitySkeleton, null)) : (React.createElement("div", null,
        React.createElement(Flagged, { title: model.flagged ? "Mark as unflagged" : "Mark as flagged", isFlagged: model.flagged, onClick: () => onToggle(), disabled: disabled, hook: "activity-togglee-" + (model.flagged ? "true" : "false") }),
        React.createElement(Typography, { "data-test": "activity-title" },
            React.createElement("strong", null, createdByName),
            " added an email from",
            " ",
            React.createElement("strong", null,
                eventMeta.fromName,
                " ",
                eventMeta.fromName ? (React.createElement("span", null,
                    "(",
                    eventMeta.fromAddress,
                    ")")) : (React.createElement("span", null, eventMeta.fromAddress)))),
        React.createElement(Divider, null),
        React.createElement("div", { "data-test": "activity-body" },
            React.createElement(Typography, { variant: "body1", className: "ActivityNote" },
                React.createElement("strong", null, eventMeta.subject)),
            React.createElement(Typography, { variant: "body1", className: "ActivityNote" }, eventMeta.receivedDateTime && React.createElement("span", null,
                "Received: ",
                eventMeta.receivedDateTime)),
            React.createElement(Typography, { variant: "body1", className: "ActivityNote" }, formatText(eventMeta.body || eventMeta.bodyPreview || ""))),
        eventMeta.hasAttachments &&
            eventMeta.attachments &&
            eventMeta.attachments.length &&
            eventMeta.attachments.map(attachment => {
                return (React.createElement("div", { className: "DocumentDownload", key: attachment.id },
                    React.createElement(DocumentDownloadAttachment, { caseId: caseId, id: id, attachmentId: attachment.id, label: attachment.fileName })));
            })));
};
